// extracted by mini-css-extract-plugin
export default {"listingSection":"MainDashboard_listingSection__NqDnJ","availableListingSec":"MainDashboard_availableListingSec__vHARI"};